import { defineStore } from "pinia";
import { useI18n } from "vue-i18n";
import ubistApi from "@/lib/ubistApi";
import useLoading from "@/lib/useLoading.js";
import { useCommonStore } from "@/store/common";

export const useNoticesStore = defineStore("notices", {
  state: () => {
    const { t } = useI18n();
    const { loading, loadingPattern, handleLoading } = useLoading();

    return {
      t,
      loading,
      loadingPattern,

      noticeType: 0,
      noticeDetailType: 0,

      selectedOption: 'title',
      searchKeyword: '',

      notices: [],
      notice: null,
      noticeId: null,
    }
  },
  actions: {
    async fetchNotices() {
      this.loading = true;

      const response = await ubistApi.getNoticeList(
        this.noticeType,
        this.noticeDetailType,
        this.selectedOption,
        this.searchKeyword
      );

      this.notices = response.data;

      this.loading = false;

      return this.notices;
    },
    async fetchNoticeDetail() {
      this.loading = true;

      const response = await ubistApi.getNotice(this.noticeType, this.noticeId);
      this.notice = response.data;

      console.log("fetchNoticeDetail notice:", response.data);

      this.loading = false;
      return this.notice;
    },
    async downloadNoticeFile(fileId, fileName) {
      this.loading = true;
      
      const response = await ubistApi.downloadNoticeFile(this.noticeType, this.noticeId, fileId);
      var blob = response.data;
      // 파일 다운로드를 위한 링크 생성
      const urlLink = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = urlLink;
      a.download = fileName;

      // 다운로드 링크 클릭
      a.click();

      // URL 객체 해제
      window.URL.revokeObjectURL(urlLink);
      
      this.loading = false;
    },
  },
  getters: {},
});
